import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'webapp-compat-messaging',
  template: `
    <app-messaging [hideMessaging]="hideMessaging"></app-messaging>
    <router-outlet></router-outlet>
  `,
})
export class CompatMessagingComponent implements OnInit {
  hideMessaging = false;

  ngOnInit() {
    const w = <any>window;
    this.hideMessaging =
      w &&
      w.webappCompat &&
      w.webappCompat.messaging &&
      w.webappCompat.messaging.hide_messaging;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/it/webapp/src/compat/compat-messaging.component.ts